import { create } from 'zustand'

interface State {
  dialogComponent: React.ReactNode
  visible: boolean
}

interface Action {
  changeDialogComponent: ({ dialogComponent }: { dialogComponent: State['dialogComponent'] }) => void
  changeVisible: ({ visible }: { visible: State['visible'] }) => void
}

export const dialogStore = create<State & Action>((set) => ({
  dialogComponent: null,
  visible: false,
  changeDialogComponent: ({ dialogComponent }) => set(() => ({ dialogComponent: dialogComponent })),
  changeVisible: ({ visible }) => set(() => ({ visible: visible })),
}))
